import { ToastContainer } from 'react-toastify';

const Toastify = () => (
  <ToastContainer position="top-right" autoClose={4000} pauseOnFocusLoss closeOnClick />
);

export default Toastify;
